import { api, getDataSimple } from "../helpers/apiHelper";
const API_PROFILE = "/account";
export const changePassword = (
  userId: number,
  accountId: number,
  password: string,
  newPassword: string,
  retypePassword: string
): any => {
  const url = API_PROFILE;
  // update with account data
  const data = {
    userId: userId,
    accountId: accountId,
    password: password,
    newPassword: newPassword,
    passwordConfirmation: retypePassword,
  };

  return api
    .put(url, data)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * PUT update secret question
 */
export const updateSecretQuestion = (
  userId: number,
  accountId: number,
  password: string,
  securityQuestionAnswer: string,
  securityQuestionid: string
): any => {
  const url = API_PROFILE;
  // update with account data
  const data = {
    userId: userId,
    accountId: accountId,
    password: password,
    securityQuestionAnswer: securityQuestionAnswer,
    securityQuestionId: securityQuestionid,
  };
  return api
    .put(url, data)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * fetch current report list
 */
export const fetchAccountDetails = (): any => {
  const url = API_PROFILE;
  return getDataSimple(url);
};

/**
 * fetch settled report list
 */
export const fetchSettledReportList = (): any => {
  const url = API_PROFILE + "settled?per-page=200";
  return getDataSimple(url);
};

/**
 * update account details
 */
export const updateAccountDetails = (data: any): any => {
  const url = API_PROFILE;
  return api
    .put(url, data)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * update max stake
 */
export const updateMaxStake = (
  userId: number,
  accountId: number,
  oddsType: string,
  maximumStake: string
): any => {
  const url = API_PROFILE;
  const data = {
    userId: userId,
    accountId: accountId,
    preferences: {
      oddsType: oddsType,
      maximumStake: maximumStake,
    },
  };
  return api
    .put(url, data)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * update language
 */
export const updateLanguage = (
  userId: number,
  accountId: number,
  oddsType: string,
  language: string
): any => {
  const url = API_PROFILE;
  const data = {
    userId: userId,
    accountId: accountId,
    preferences: {
      language: language,
      oddsType: oddsType,
    },
  };
  return api
    .put(url, data)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * PUT update t&c
 */
export const updateTAC = (
  userId: number,
  accountId: number,
  confirmedTerms: boolean,
  versionTermsAndConditions: string
): any => {
  const url = API_PROFILE;
  const data = {
    userId: userId,
    accountId: accountId,
    confirmedTerms: confirmedTerms,
    versionTermsAndConditions: versionTermsAndConditions,
  };
  return api
    .put(url, data)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};
